import { identity, pickBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useEmbeddedAPI from '@swf/core/hooks/useEmbeddedAPI';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import type { CasinoBonusGame, SpinOfDayData } from '@swf/core/types/CasinoBonus';

const useCasinoBonusGame = (): React.Dispatch<
  React.SetStateAction<CasinoBonusGame | undefined>
> => {
  const [game, setGame] = useState<CasinoBonusGame>();
  const { modal } = useDispatch<Dispatch>();
  const { bonusId, bonusCampaignId, numberOfSpins } = (game || {}) as SpinOfDayData;
  const host = useSelector(select.site.getBrandCode);
  const brand = useSelector(select.site.getBrand);
  const site = useSelector(select.site.getId);
  const platform = useSelector(select.casino.getPlatform);
  const query = pickBy(
    {
      bonusCampaignId,
      bonusId,
      numberOfSpins,
      useNativeClose: true,
      hostapptype: 'WSL',
      host,
      brand,
      site,
      platform
    },
    identity
  );

  useEmbeddedAPI();

  useEffect(() => {
    if (game) {
      modal.enqueue({
        path: '/casino/game-overlay',
        locationState: { gameUrl: game.gameURL, query, title: 'CasinoBonusGame' }
      });
      setGame(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [game]);

  return setGame;
};

export default useCasinoBonusGame;
